const listaDeModulos = (state) => {
    return state.items;
}

const loadingModulos = (state) => {
    return state.carregando;

}

export {
    listaDeModulos,
    loadingModulos
}